import {
  WHATSAPP_GET_LIST,
  WHATSAPP_GET_LIST_SUCCESS,
  WHATSAPP_GET_LIST_ERROR,
  WHATSAPP_UPDATE_ITEM,
  WHATSAPP_UPDATE_SESSION,
  WHATSAPP_DELETE_ITEM,
  WHATSAPP_ADD_ITEM,
  WHATSAPP_RESET_LIST,
} from '../contants';

const INIT_STATE = {
  whatsApps: [],
  loading: false,
  error: '',
  loaded: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case WHATSAPP_GET_LIST:
      return { ...state, loading: true, error: '' };

    case WHATSAPP_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        whatsApps: action.payload,
        error: '',
      };

    case WHATSAPP_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload,
      };

    case WHATSAPP_UPDATE_ITEM: {
      const whatsApp = action.payload;
      const whatsAppIndex = state.whatsApps.findIndex(w => w.id === whatsApp.id);
      
      if (whatsAppIndex !== -1) {
        const updatedWhatsApps = [...state.whatsApps];
        updatedWhatsApps[whatsAppIndex] = whatsApp;
        return { ...state, whatsApps: updatedWhatsApps };
      } else {
        return { ...state, whatsApps: [whatsApp, ...state.whatsApps] };
      }
    }

    case WHATSAPP_UPDATE_SESSION: {
      const session = action.payload;
      const whatsAppIndex = state.whatsApps.findIndex(w => w.id === session.id);
      
      if (whatsAppIndex !== -1) {
        const updatedWhatsApps = [...state.whatsApps];
        updatedWhatsApps[whatsAppIndex] = {
          ...updatedWhatsApps[whatsAppIndex],
          status: session.status,
          updatedAt: session.updatedAt,
          qrcode: session.qrcode,
          retries: session.retries,
        };
        return { ...state, whatsApps: updatedWhatsApps };
      }
      return state;
    }

    case WHATSAPP_DELETE_ITEM: {
      const whatsAppId = action.payload;
      const filteredWhatsApps = state.whatsApps.filter(w => w.id !== whatsAppId);
      return { ...state, whatsApps: filteredWhatsApps };
    }

    case WHATSAPP_ADD_ITEM:
      return {
        ...state,
        whatsApps: [action.payload, ...state.whatsApps],
      };

    case WHATSAPP_RESET_LIST:
      return {
        ...state,
        whatsApps: [],
        loading: false,
        error: '',
        loaded: false,
      };

    default:
      return state;
  }
};
